module.exports = __webpack_public_path__ + "img/persis-foods-gray.ce5b4bf.png";